import {useState, useEffect} from 'react'
import PropTypes from 'prop-types'
import {fetchFutureEvents, fetchPastEvents} from './utils'

function MeetupsLoader({children, spinner, error: errorFunc, orgId}) {
	const [loadingState, setLoadingState] = useState({data: undefined, error: null, loading: true})

	const loadEvents = async () => {
		setLoadingState({loading: true, data: undefined, error: null})
		try {
			const data = {
				past: await fetchPastEvents({orgId}),
				future: await fetchFutureEvents({orgId}),
			}
			setLoadingState({loading: false, data, error: null})
		} catch (error) {
			setLoadingState({loading: false, data: undefined, error})
		}
	}
	useEffect(() => {
		loadEvents()
	}, [])

	const {data, error, loading} = loadingState


	if (loading) return spinner
	if (error) return errorFunc({error, retry: () => loadEvents()})
	if (data !== undefined) return children(data)
}


MeetupsLoader.propTypes = {
	className: PropTypes.string,
	children: PropTypes.func.isRequired,
	orgId: PropTypes.string.isRequired,
	spinner: PropTypes.node,
	error: PropTypes.func.isRequired,
}

MeetupsLoader.defaultProps = {
	className: '',
}

export default MeetupsLoader
